var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubscription(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 490,
    viewBox: "0 0 512 490",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "responsive",
    transform: "translate(0 -11)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_300",
    "data-name": "Ellipse 300",
    cx: 245,
    cy: 245,
    r: 245,
    transform: "translate(22 11)",
    fill: "rgba(255,195,10,0.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_515",
    "data-name": "Rectangle 515",
    width: 78.71,
    height: 41.23,
    transform: "translate(185.72 358.53)",
    fill: "#445ea0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_516",
    "data-name": "Rectangle 516",
    width: 19.842,
    height: 41.23,
    transform: "translate(185.72 358.53)",
    fill: "#2e4c89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M316.856,398.763H127.56a5.116,5.116,0,0,0-5.1,5.1v25.571a5.117,5.117,0,0,0,5.1,5.1h189.3V398.763Z",
    fill: "#293d7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M142.3,429.435V403.864a5.117,5.117,0,0,1,5.1-5.1H127.56a5.116,5.116,0,0,0-5.1,5.1v25.571a5.117,5.117,0,0,0,5.1,5.1H147.4A5.117,5.117,0,0,1,142.3,429.435Z",
    fill: "#1a2b63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M445.054,58.964H5.1a5.117,5.117,0,0,0-5.1,5.1V354.43a5.116,5.116,0,0,0,5.1,5.1H316.856V206.768a7.008,7.008,0,0,1,7-7h126.3V64.066A5.117,5.117,0,0,0,445.054,58.964Z",
    fill: "#293d7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M22.4,308.514a3.069,3.069,0,0,0,3.061,3.06h291.4V206.768a7.008,7.008,0,0,1,7-7h103.9V109H22.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M42.239,308.514V109H22.4V308.514a3.069,3.069,0,0,0,3.061,3.06H45.3A3.069,3.069,0,0,1,42.239,308.514Z",
    fill: "#d9eafc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301",
    "data-name": "Ellipse 301",
    cx: 13.774,
    cy: 13.774,
    r: 13.774,
    transform: "translate(211.306 321.686)",
    fill: "#445ea0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M316.856,223.146H263.432a3.009,3.009,0,0,0-3,3v59.639a3.009,3.009,0,0,0,3,3h53.424Z",
    fill: "#c3ddf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M280.274,285.785V226.146a3.009,3.009,0,0,1,3-3H263.432a3.009,3.009,0,0,0-3,3v59.639a3.009,3.009,0,0,0,3,3h19.842A3.009,3.009,0,0,1,280.274,285.785Z",
    fill: "#aec1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M323.856,199.768h46.618V134.386a5.015,5.015,0,0,0-5-5H84.682a5.015,5.015,0,0,0-5,5v66.525a5.015,5.015,0,0,0,5,5H316.915A7.006,7.006,0,0,1,323.856,199.768Z",
    fill: "#c3ddf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M99.524,200.91V134.385a5.015,5.015,0,0,1,5-5H84.682a5.015,5.015,0,0,0-5,5V200.91a5.015,5.015,0,0,0,5,5h19.842A5.015,5.015,0,0,1,99.524,200.91Z",
    fill: "#aec1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M424.7,84.983H25.457A3.07,3.07,0,0,0,22.4,88.045V110H427.76V88.045A3.07,3.07,0,0,0,424.7,84.983Z",
    fill: "#fe3f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M45.3,84.983H25.457A3.07,3.07,0,0,0,22.4,88.045V110H42.238V88.045A3.071,3.071,0,0,1,45.3,84.983Z",
    fill: "#fa243a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_744",
    "data-name": "Group 744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    d: "M171.5,238.979H87.334a7.5,7.5,0,0,1,0-15H171.5a7.5,7.5,0,0,1,0,15Z",
    fill: "rgba(14,127,138,0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    d: "M171.5,263.466H87.334a7.5,7.5,0,0,1,0-15H171.5a7.5,7.5,0,1,1,0,15Z",
    fill: "rgba(14,127,138,0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M171.5,287.953H87.334a7.5,7.5,0,0,1,0-15H171.5a7.5,7.5,0,0,1,0,15Z",
    fill: "rgba(14,127,138,0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    d: "M237.56,238.979H194.234a7.5,7.5,0,0,1,0-15H237.56a7.5,7.5,0,0,1,0,15Z",
    fill: "rgba(14,127,138,0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M237.56,263.466H194.234a7.5,7.5,0,1,1,0-15H237.56a7.5,7.5,0,0,1,0,15Z",
    fill: "rgba(14,127,138,0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M237.56,287.953H194.234a7.5,7.5,0,0,1,0-15H237.56a7.5,7.5,0,0,1,0,15Z",
    fill: "rgba(14,127,138,0.6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M504,198.768a8.024,8.024,0,0,1,8,8v241.77a8.024,8.024,0,0,1-8,8H323.856a8.024,8.024,0,0,1-8-8V206.768a8.024,8.024,0,0,1,8-8Z",
    fill: "#445ea0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M337.567,425.125a5.015,5.015,0,0,1-5-5V219.18a5.015,5.015,0,0,1,5-5H490.29a5.015,5.015,0,0,1,5,5V420.125a5.015,5.015,0,0,1-5,5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M352.409,420.125V219.18a5.015,5.015,0,0,1,5-5H337.567a5.015,5.015,0,0,0-5,5V420.125a5.015,5.015,0,0,0,5,5h19.842A5.015,5.015,0,0,1,352.409,420.125Z",
    fill: "#d9eafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    d: "M404.567,445.125a5.015,5.015,0,0,1-5-5V438.18a5.015,5.015,0,0,1,5-5H423.29a5.015,5.015,0,0,1,5,5v1.945a5.015,5.015,0,0,1-5,5Z",
    fill: "#445ea0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    d: "M495.29,233.473V219.18a5.015,5.015,0,0,0-5-5H337.567a5.015,5.015,0,0,0-5,5v14.293Z",
    fill: "#fe3f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    d: "M357.409,214.18H337.567a5.015,5.015,0,0,0-5,5v14.293h19.842V219.18A5.015,5.015,0,0,1,357.409,214.18Z",
    fill: "#fa243a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_745",
    "data-name": "Group 745"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    d: "M448.013,324.933H379.844a7.5,7.5,0,0,1,0-15h68.169a7.5,7.5,0,1,1,0,15Z",
    fill: "rgba(14,127,138,0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    d: "M448.013,348.06H379.844a7.5,7.5,0,0,1,0-15h68.169a7.5,7.5,0,0,1,0,15Z",
    fill: "rgba(14,127,138,0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    d: "M448.013,371.185H379.844a7.5,7.5,0,0,1,0-15h68.169a7.5,7.5,0,0,1,0,15Z",
    fill: "rgba(14,127,138,0.6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M479.756,292.257a5.015,5.015,0,0,1-5,5H353.1a5.015,5.015,0,0,1-5-5V251.013a5.015,5.015,0,0,1,5-5H474.756a5.015,5.015,0,0,1,5,5Z",
    fill: "#c3ddf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M367.943,292.257V251.013a5.015,5.015,0,0,1,5-5H353.1a5.015,5.015,0,0,0-5,5v41.244a5.015,5.015,0,0,0,5,5h19.842A5.015,5.015,0,0,1,367.943,292.257Z",
    fill: "#aec1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M461.757,409.416a5.015,5.015,0,0,1-5,5H371.1a5.015,5.015,0,0,1-5-5v-16.91a5.015,5.015,0,0,1,5-5h85.657a5.015,5.015,0,0,1,5,5v16.91Z",
    fill: "#c3ddf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M385.942,409.416v-16.91a5.015,5.015,0,0,1,5-5H371.1a5.015,5.015,0,0,0-5,5v16.91a5.015,5.015,0,0,0,5,5h19.842A5.015,5.015,0,0,1,385.942,409.416Z",
    fill: "#aec1ed"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.3adbb4c9ffe327bdca67f606ddc98ca0.svg";
export { ForwardRef as ReactComponent };